import { Link } from "react-router-dom";
import { categories } from "@/utils/news";

export default function CategoryQuickEntry() {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
      {categories.map((cat) => (
        <Link
          key={cat.id}
          to={`/category/${cat.id}`}
          className="group p-4 md:p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-400 transition-colors cursor-pointer"
        >
          <span className="w-11 h-11 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
            <i className={`${cat.icon} text-xl`} />
          </span>
          <h3 className="text-base font-bold text-foreground-950">{cat.name}</h3>
          <p className="text-xs text-foreground-500 mt-1.5 leading-relaxed line-clamp-2">{cat.description}</p>
          <span className="inline-flex items-center gap-1 text-xs text-primary-600 mt-3 font-medium">
            进入栏目 <i className="ri-arrow-right-line" />
          </span>
        </Link>
      ))}
    </div>
  );
}